import { get, post, getToken } from "./axiosApi";
import { env } from "utils/env";
import { objToQueryString } from "utils/functions";

const url =
  env.REACT_APP_USE_DEDICATED_REPORTING_SERVICE === "true"
    ? env.REACT_APP_REPORTING_API_URL
    : env.REACT_APP_LEASING_API_URL;

class ReportsApi {
  static getReports(filters, page, pageSize) {
    const qs = objToQueryString({ ...filters, page, pageSize });
    return get(`${url}/reports?${qs}`);
  }

  static getReport(reportId) {
    return get(`${url}/reports/${reportId}`);
  }

  static generateReport(report) {
    return post(`${url}/reports/generateReport`, report);
  }

  static buildDownloadUrl(filePath, fileName) {
    return `${url}/reports/documents/${encodeURIComponent(filePath)}/${encodeURIComponent(
      fileName
    )}?access_token=${getToken()}`;
  }

  static getReportLookupDataSource(reportId, reportFilterId) {
    return post(`${url}/reports/${reportId}/filters/${reportFilterId}/lookupDataSource`, {});
  }

  static getReportBrowser(reportFilterId, reportId) {
    return post(`${url}/reports/browsers/`, { reportFilterId, reportId });
  }

  static getReportBrowserData(filters, page, pageSize, reportFilterId, reportId, order, orderBy, orderByFieldName) {
    return post(`${url}/reports/browserData`, {
      filters,
      page,
      pageSize,
      reportFilterId,
      reportId,
      order,
      orderBy,
      orderByFieldName
    });
  }

  static getBrowserLookupDataSource(browserName, filterName) {
    return post(`${url}/reports/browserLookupDataSource`, { browserName, filterName });
  }
}

export default ReportsApi;
